const map = {
	"./COGNEESOL_LOGO.png": 6619,
	"./FWS_LOGO.png": 1954,
	"./activeAudits.svg": 6510,
	"./agent.svg": 7352,
	"./auditAgent.svg": 5812,
	"./auditAuditor.svg": 7097,
	"./auditCalendar.svg": 9239,
	"./auditClient.svg": 2048,
	"./auditCount.svg": 2370,
	"./auditDepartment.svg": 4459,
	"./auditFatel.svg": 1205,
	"./auditForm.svg": 2767,
	"./auditId.svg": 3774,
	"./auditInsure.svg": 8531,
	"./auditNoFatel.svg": 7574,
	"./auditProcess.svg": 5708,
	"./auditScore.svg": 4321,
	"./auditScoree.svg": 7214,
	"./auditStag.svg": 4188,
	"./auditTransaction.svg": 4571,
	"./audited.svg": 5034,
	"./auditor.svg": 1250,
	"./closeIcon.svg": 3903,
	"./dashboardIcon.svg": 2623,
	"./dashboardUser.svg": 7093,
	"./departmentAction.svg": 76,
	"./departmentDate.svg": 5278,
	"./departmentIcon.svg": 4065,
	"./departmentName.svg": 4559,
	"./departmentStatus.svg": 7000,
	"./downloadIcon.svg": 1675,
	"./fatelCount.svg": 823,
	"./invoiceCount.svg": 8958,
	"./link.svg": 9200,
	"./loginMedia.jpg": 4581,
	"./loginMedia.svg": 6489,
	"./logo.svg": 5941,
	"./manageUsers.svg": 1311,
	"./menuIcon.svg": 7554,
	"./microsoft.svg": 2700,
	"./noData.svg": 5013,
	"./nonFatelCount.svg": 5102,
	"./profileIcon.svg": 624,
	"./qmsIcon.svg": 1446,
	"./reasonIcon.svg": 9447,
	"./searchIcon.svg": 3319,
	"./settingsIcon.svg": 9160,
	"./supervisor.svg": 2982,
	"./surveyLogo.svg": 7811,
	"./switch.svg": 3852,
	"./totalAudits.svg": 3502,
	"./transactionId.svg": 255,
	"./voc.svg": 3708
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;